const CourseSchedulesStore = require('./CourseSchedules').default;

export default new Vuex.Store({
    modules: {
        schedule: CourseSchedulesStore,
    },
    state: {
        messages: [],
    },
    mutations: {
        clear: (state) => {
            state.messages = [];
        },
        add_message: (state, message) =>  {
            state.messages.push(message);
        },
        hide_message: (state, messageIndex) =>  {
            state.messages[messageIndex].show = false;
        },
    },
    getters: {
        messages: state => {
            return state.messages;
        }
    },
    actions: {

    }
});
